export default {
  modals: {
    appliedRulesReview: {},
    profile: {
      edit: () => {}
    },
    editProfile: {},

    shift: {},
    editShift: {},

    sequenceReview: {
      onSave: () => {}
    },

    attachedView: { onUpdate: () => {}, onRenew: () => {} },
    attachedCreate: { save: () => {} },

    documentView: {},
    documentCreate: { edit: () => {} },
    assignmentRequestReview: { onReviewed: () => {} },

    backfill: { add: () => {} },
    joinProject: { save: () => {}, change: () => {} },

    dynamicForm: { save: () => {} },

    legalEntity: { add: () => {} },

    timeOff: { update: () => {} },

    shiftView: { edit: () => {} },
    notification: { edit: () => {} },
    payment: { edit: () => {} },
    requestPayment: { onCompleted: () => {} },
    finalPaycheck: { onCompleted: () => {} },
    tableExport: { export: () => {} },
    deletion: { onConfirm: () => {} }
  }
}
